import ModelsProvider, { IModelProvider } from "../ModelsProvider";

export default class SharedModelsProvider extends ModelsProvider implements IModelProvider{
  constructor(public name: string) {
    super();
  }
}
